<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs">Balances</p>
        <h2 class="">Balances</h2>
    </div>
    <dx-button [visible]="visibleBalanceBtn" [disabled]="disableBalanceBtn" text="Agregar fondos" icon="plus" type="default" (onClick)="newBalance()"></dx-button>
</div>
<div class="content-block">
    <div class="dx-card responsive-paddings">
        <dx-data-grid [dataSource]="balances" keyExpr="id" [showBorders]="true"
            [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }">
            <dxo-load-panel [enabled]="true"></dxo-load-panel>
            <dxi-column dataField="companyName" caption="Empresa" sortOrder="asc"></dxi-column>
            <dxi-column dataField="companyLegalName" caption="Razón Social"></dxi-column>
            <dxi-column dataField="balance" caption="Balance" dataType="number" format="currency">
                <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <dxo-paging [pageSize]="50"> </dxo-paging>
            <div *dxTemplate="let movements of 'detail'">
                <dx-data-grid [dataSource]="movements.data.transactions" showBorders="true">
                    <dxi-column dataField="conceptId" caption="Concepto" cellTemplate="conceptTemplate"
                        alignment="center"></dxi-column>
                    <dxi-column dataField="date" caption="Fecha" cellTemplate="dateTemplate" alignment="center"
                        sortOrder="desc">
                    </dxi-column>
                    <dxi-column dataField="deposit" caption="Depósito" dataType="number" format="currency"
                        alignment="center">
                        <dxo-format type="currency" [precision]="2"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="withdraw" caption="Dispersión" dataType="number" format="currency"
                        alignment="center">
                        <dxo-format type="currency" [precision]="2"></dxo-format>
                    </dxi-column>
                    <dxi-column dataField="dispersionId" caption="ID Dispersión"></dxi-column>
                    <div *dxTemplate="let d of 'dateTemplate'">
                        <div *ngIf="d.value"> {{d.value|numberToDate}}</div>
                    </div>
                    <div *dxTemplate="let concept of 'conceptTemplate'">
                        <div *ngIf="concept.value === 1">Depósito </div>
                        <div *ngIf="concept.value === 2">Dispersión </div>
                        <div *ngIf="concept.value === 3">Otro </div>
                        <!-- 1 = deposit, 2 = dispersion, 3 = other -->
                    </div>
                </dx-data-grid>
                <!-- {{movements.data | json}} -->
            </div>
            <dxo-summary>
                <dxi-total-item
                    column="companyName"
                    summaryType="count">
                </dxi-total-item>
                <dxi-total-item
                    column="balance"
                    valueFormat="currency"
                    displayFormat="Sum: ${0}"
                    summaryType="sum">
                    <dxo-value-format type="fixedPoint" precision="2"></dxo-value-format>
                </dxi-total-item>
            </dxo-summary>
        </dx-data-grid>
    </div>
</div>
<!-- POP UP  -->
<dx-popup [width]="450" [height]="470" [showTitle]="true" title="Agregar fondos a cuenta" [dragEnabled]="false"
    [closeOnOutsideClick]="true" [(visible)]="popupVisible">
    <div *dxTemplate="let data of 'content'">
        <div class='dx-field mt-3'>
            <div class='dx-field-label'>Empresa</div>
            <div class='dx-field-value'>
                <dx-select-box [dataSource]="companies" displayExpr="companyName" valueExpr="id"
                    [(value)]="newBalanceEntry.companyId">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
        </div>
        <div class='dx-field'>
            <div class='dx-field-label'>Cantidad a depositar</div>
            <div class='dx-field-value'>
                <dx-number-box format="$ #,##0.##" [(value)]="newBalanceEntry.deposit">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                        <dxi-validation-rule type="range" min="1" message="Error"></dxi-validation-rule>
                    </dx-validator>
                </dx-number-box>
            </div> 
        </div>
        <div class="dx-field">
            <div class="dx-field-label">{{invoicesAvailibles}}: <dx-switch (onValueChanged)="isCreatInvove($event.value)" [value]="isVisibleInvoiceBtn"></dx-switch></div>
        </div>
        <p class="txt-center">IMPORTANTE: Solamente agregar la cantidad a Dispersar SIN IVA ni comisión</p>
        <div class="flex flex-no-wrap flex-space-between flex-align-center mt-4 mb-2">
            <dx-button id="cancelBtn" type="warning" (onClick)="cancelBalance()" text="Cancelar" class="txt-center">
            </dx-button>
            <dx-button id="button" [useSubmitBehavior]="true" type="default" (onClick)="addNewBalance($event)"
                text="Guardar" class="float-right"  [disabled]="isVisibleBalanceBtn">
            </dx-button>
        </div>
    </div>
</dx-popup>